var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckPrimaryIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12,
    r: 11.5,
    fill: "white",
    stroke: "#2D6CE6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.20167 12.267L10.504 13.542C10.8928 13.9602 11.5255 13.9602 11.915 13.5412L16.7983 8.31339C17.1882 7.89491 17.8196 7.89566 18.2086 8.31494C18.5977 8.73428 18.597 9.4134 18.2072 9.83183L13.3246 15.0589C12.1581 16.3136 10.2601 16.3136 9.09442 15.0597L7.79284 13.7855C7.59763 13.576 7.5 13.3012 7.5 13.0263C7.5 12.7522 7.59713 12.478 7.79139 12.2686C8.18041 11.8493 8.81181 11.8486 9.20167 12.267Z",
    fill: "#2D6CE6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckPrimaryIcon);
export default __webpack_public_path__ + "static/media/check-primary-icon.9745c0f22eff2d5a040306848f946d46.svg";
export { ForwardRef as ReactComponent };